/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDeviceIpadHorizontalShare = createReactComponent(
  "device-ipad-horizontal-share",
  "IconDeviceIpadHorizontalShare",
  [
    [
      "path",
      {
        d: "M12.5 20h-7.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7",
        key: "svg-0"
      }
    ],
    ["path", { d: "M9 17h3", key: "svg-1" }],
    ["path", { d: "M16 22l5 -5", key: "svg-2" }],
    ["path", { d: "M21 21.5v-4.5h-4.5", key: "svg-3" }]
  ]
);

export { IconDeviceIpadHorizontalShare as default };
//# sourceMappingURL=IconDeviceIpadHorizontalShare.js.map
